// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class Role {
  readonly id: string;
  readonly name: Enums.RoleName;
  readonly customName: string | null;
  readonly permissions: Enums.Permission[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? Enums.RoleName.Salesperson : data.name;
    this.customName = data.customName === undefined ? null : data.customName;
    this.permissions = (data.permissions ?? []).map((permissions: any) =>
      permissions === undefined ? Enums.Permission.ViewCostData : permissions,
    );
  }

  static zero(): Role {
    const zeroValues: ExcludeMethodsDeep<Role> = {
      id: NIL_UUID,
      name: Enums.RoleName.Salesperson,
      customName: null,
      permissions: [],
    };
    return new Role(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  displayName(): string {
    return this.customName ?? this.name;
  }
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type RoleWireFormat = {
  id: string;
  name: string;
  customName: string | null;
  permissions: string[];
};

type NewRoleProps = PartialDeep<Role, { recurseIntoArrays: true }>;
export const NewRole: (props: NewRoleProps) => Role = (props) => new Role(props);

type NewRoleFromWireFormatProps = PartialDeep<RoleWireFormat, { recurseIntoArrays: true }>;
export const NewRoleFromWireFormat: (props: NewRoleFromWireFormatProps) => Role = (props) =>
  new Role(props);
